import { render, staticRenderFns } from "./item-content.vue?vue&type=template&id=285a9631&"
import script from "./item-content.vue?vue&type=script&lang=ts&"
export * from "./item-content.vue?vue&type=script&lang=ts&"
import style0 from "./item-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports